import * as React from 'react'
import { useLocation } from 'react-router'

import TrackedExternalLink from './common/TrackedExternalLink'
import Text from './common/Text'

import theme from 'theme'

const FooterLink: React.FC<{ darkTheme?: boolean }> = ({
  darkTheme,
  ...rest
}) => (
  <TrackedExternalLink
    className="FooterLink"
    css={{
      fontWeight: theme.fontWeights[0],
      color: darkTheme ? theme.colors.white[0] : theme.colors.steel[1],

      '&:hover, &:focus': {
        color: darkTheme ? theme.colors.white[0] : theme.colors.blue[0]
      }
    }}
    {...rest}
  />
)

const Footer: React.FC = () => {
  const location = useLocation()

  const darkTheme = location.pathname.startsWith('/onboarding')

  return (
    <footer
      css={{
        minHeight: 'var(--header-height)',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        background: darkTheme ? theme.colors.steel[2] : theme.colors.panel[0],
        borderTop: darkTheme ? 'none' : theme.border.base,
        paddingTop: theme.space[3],
        paddingBottom: theme.space[3],
        paddingRight: theme.space[8] + theme.space[5] + theme.space[3], // Takes care of floating button
        paddingLeft: theme.space[4],

        [theme.mq[1]]: {
          flexDirection: 'row',
          alignItems: 'center'
        },

        [theme.mq[2]]: {
          paddingLeft: theme.space[7]
        }
      }}
    >
      <Text
        as="h4"
        css={{
          marginBottom: theme.space[1],
          color: darkTheme ? theme.colors.white[0] : theme.colors.steel[2],

          [theme.mq[1]]: {
            marginBottom: 0,
            marginRight: theme.space[2]
          }
        }}
      >
        &copy; {new Date().getFullYear()} Gremlin Inc.
      </Text>
      <div
        css={{
          display: 'flex',
          flexWrap: 'wrap',
          margin: `-${theme.space[4]}px 0 0 -${theme.space[4]}px`,

          '.FooterLink': {
            marginTop: theme.space[4],
            marginLeft: theme.space[4]
          },

          [theme.mq[1]]: {
            marginLeft: 'auto'
          }
        }}
      >
        <FooterLink darkTheme={darkTheme} href="https://www.gremlin.com/blog/">
          Blog
        </FooterLink>
        <FooterLink
          darkTheme={darkTheme}
          href="https://www.gremlin.com/contact/"
        >
          Contact Us
        </FooterLink>
      </div>
    </footer>
  )
}

export default Footer
